import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { IoMdLogOut } from "react-icons/io";
import { FaBars } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import { GiCyberEye } from "react-icons/gi";

import { MenuItems } from './menuItems';
import { useAuth } from 'pages/Login/useAuth';
import {
  setAuthHeader,
  setCurrentUser,
  setLogoutState
} from 'redux/authentication/auth.actions';
import './navbar.style.css';

const NavBar = ({
  isLoggedOut,
  currentUser,
  setAuthHeader,
  setCurrentUser,
  setLogoutState
}) => {
  const auth = useAuth();
  const [clicked, setClicked] = useState(false);
  const isStaging = window.location.href.includes('-staging.');

  const handleClick = () => {
    setClicked(prev => !prev);
  };

  const initiateLogout = () => {
    localStorage.removeItem('__TOKEN__');
    setAuthHeader(null);
    setCurrentUser(null);
    setLogoutState(true);
  };

  const initiateLogin = () => {
    setLogoutState(false);
    localStorage.setItem('__PATH_AFTER_LOGOUT__', '/');
    auth.removeToken();
  }

  return (
    <nav className={`navbar-items ${isStaging ? ' staging' : ''}`}>
      <Link className='app-logo-container' to='/'>
        <GiCyberEye className='app-logo' />
        <p className='app-name'>
          WPV
        </p>
      </Link>
      {currentUser && (
        <>
          <div className="menu-icon" onClick={handleClick}>
            {clicked ? <AiOutlineClose className='cross-bars' /> : <FaBars className='cross-bars' />}
          </div>
          <ul className={clicked ? 'nav-menu active' : 'nav-menu'}>
            {
              MenuItems.map((item, index) => {
                return (
                  <li key={index}>
                    <NavLink activeClassName={isStaging ? 'active-staging' : 'active'} exact to={item.url}>
                      {item.title}
                    </NavLink>
                  </li>)
              })
            }
            <li>
              <Link className='button-container' to='/logout'>
                <div className='tooltip-user-name'>
                  <div className="tooltiptext-user-name">logged in as <br /> {currentUser} </div>
                  <span><IoMdLogOut className='logout-button' onClick={() => initiateLogout()} /></span>
                </div>
              </Link>
            </li>
          </ul>
        </>
      )}
      {isLoggedOut && (
        <Link className='button-container login'>
          <div className='tooltip-login'>
            <div className="tooltiptext-login">Log in</div>
            <span><IoMdLogOut className='login-button' onClick={() => initiateLogin()} /></span>
          </div>
        </Link>
      )}
    </nav>
  )
};

const mapStateToProps = ({
  authentication: { currentUser, isLoggedOut } }) => ({
    currentUser,
    isLoggedOut
  });

const mapDispatchToProps = dispatch => ({
  setAuthHeader: token => dispatch(setAuthHeader(token)),
  setCurrentUser: user => dispatch(setCurrentUser(user)),
  setLogoutState: state => dispatch(setLogoutState(state)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NavBar);